
import axios from 'axios';
import api from './api';

const poll = {
    async get (survey) {
        try {
            const { data: { questions }  } = await axios.get(`${api.base}/surveys/${survey}`);
            return questions;
        }
        catch (error) {
            console.log(error);
        }
    },
    async submit (id, survey, key) {
        try {
            const result = await axios.post(
                `${api.base}/surveys/${survey}/responses`,
                {
                    userId: id,
                    responses: key,
                },
            );
            return result;
        }
        catch (error) {
            console.log(error);
        }
    },
};

export default poll;
